import { createContext } from 'react';

var InstantSearchRSCContext = createContext({
    countRef: {
        current: 0
    },
    waitForResultsRef: null,
    ignoreMultipleHooksWarning: false
});

export { InstantSearchRSCContext };
